




















import { Component, Mixins } from 'vue-property-decorator';
import { DownloadState } from '@/services/Downloads';
import { DownloadListenerMixin } from './DownloadListenerMixin';

@Component({})
export class DownloadIcon extends Mixins(DownloadListenerMixin) {
	private readonly DownloadState = DownloadState;
}

export default DownloadIcon;
